import { render, staticRenderFns } from "./ContactStats.vue?vue&type=template&id=3220be90"
import script from "./ContactStats.vue?vue&type=script&lang=js"
export * from "./ContactStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports